import styles from "./styles.module.css";
import { getRows } from "../../../utils/databaseactions";
import { useParams } from "react-router-dom";
import { useState, useContext } from "react";
import { UserValue } from "../../../contexts/user";

export default function Reference({ type, table, id, list, active, setActive }) {
  const [data, setData] = useState(null);
  const { appId } = useParams();
  const user = useContext(UserValue);

  const getReferencedDoc = async () => {
    const ids = list ? id : [id];
    const idList = !!ids ? ids.map(cur => ({id: cur})) : [];
    setData(idList);
    /*
    try {
        const ids = list ? id : [id];
        const refData = await getRows(appId, table, ids, user);
        setData(refData);
    }
    catch (err) {
      console.log(err);
      setData(null);
    }*/
  }

  const fetchData = () => {
    if (!data) {
      getReferencedDoc();
    }
    setActive();
  }

  const displayData = () => {
    try {
      const keys = Object.keys(data[0]).sort();
      return data.map(cur => (
        keys.map(key => (
          <div key={`${cur._id}-${key}`} className={styles.referenceData}>
            <div>{key}</div>
            <div>{cur[key]}</div>
          </div>
        ))
      ));
    }
    catch (err) {
      return <div>No Data</div>
    }
  }

  const title = () => {
    if (active) {
      return (
        <em>
          {list ? 'List of ' : null}{type}
        </em>
      )
    }
    return list ? `List of ${type}` : type;
  }

  return (
    <div onClick={fetchData} className={`${styles.reference} ${active ? styles.selected : ""}`}>
      {title()}
      {active ? (
        <div className={styles.referenceModal}>
          <div>
            {!data ? <div style={{textAlign: "left"}}>Loading</div> : displayData()}
          </div>
        </div>
      ) : null}
    </div>
  )
}